import React from "react";
import "./CreativeDesignSection4.css";
import logo1 from "../../../assets/beykoy_siyah_beyaz 11.png";
import logo2 from "../../../assets/liberaldemokrasi.png";
import logo3 from "../../../assets/cypriojoblogoblackandwhite.png";
import { useTranslation } from "react-i18next";
const CreativeDesignSection4 = () => {
  const { t } = useTranslation("global");

  // Define link destinations for each logo
  const logoLinks = {
    beykoy: {
      url: "https://beykoydairy.com",
      external: true,
    },
    liberalDemokrasi: {
      url: "https://liberaldemokrasihareketi.com",
      external: true,
    },
    cyprioJobs: {
      url: "https://thevirtue.co",
      external: true,
    },
  };

  return (
    <section className="latest-projects" aria-labelledby="projects-heading">
      {/* Heading */}
      <h2 id="projects-heading" className="projects-heading">
        {t("creativeDesign4.heading")}
      </h2>
      <p className="description-creativesection4">
        {t("creativeDesign4.text")}
      </p>

      {/* Logos Section */}
      <div className="logos-creative">
        <a
          href={logoLinks.beykoy.url}
          target="_blank"
          rel="noopener noreferrer"
          className="logo-link"
          aria-label="Visit Beykoy website"
        >
          <img
            src={logo1}
            alt="Beykoy Logo"
            className="logo-creative"
            loading="lazy"
            width="200"
            height="100"
            title="Beykoy Logo"
          />
        </a>

        <a
          href={logoLinks.liberalDemokrasi.url}
          target="_blank"
          rel="noopener noreferrer"
          className="logo-link"
          aria-label="Visit Liberal Demokrasi Hareketi website"
        >
          <img
            src={logo2}
            alt="Liberal Demokrasi Hareketi Logo"
            className="logo-creative center-logo-creative"
            loading="lazy"
            width="200"
            height="100"
            title="Liberal Demokrasi Hareketi Logo"
          />
        </a>

        <a
          href={logoLinks.cyprioJobs.url}
          target="_blank"
          rel="noopener noreferrer"
          className="logo-link"
          aria-label="Visit CyprioJobs website"
        >
          <img
            src={logo3}
            alt="CyprioJobs Logo"
            className="logo-creative"
            loading="lazy"
            width="200"
            height="100"
            title="CyprioJobs Logo"
          />
        </a>
      </div>
    </section>
  );
};

export default CreativeDesignSection4;
